/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Ext_Device_CancelInputs */



/**
* | output |
* | --- |
* | "No, skip" |
*
* @param {Creator_Ext_Device_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_ext_device_cancel = /** @type {((inputs?: Creator_Ext_Device_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Ext_Device_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non, ignorer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nein, überspringen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("No, salta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет, пропустить")
	if (locale === "es") return /** @type {LocalizedString} */ ("No, salta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不，跳过")
	if (locale === "ja") return /** @type {LocalizedString} */ ("いいえ、スキップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नहीं, छोड़ दो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não, pule")
	return /** @type {LocalizedString} */ ("No, skip")
});